import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, Breadcrumb, BreadcrumbItem, Container } from 'reactstrap';
import React, { useState, useRef, Component } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import BLsTable from "../BLs/BLsTable"
import { BLsView } from "./BLsView"
import { BLsDelete } from "./BLsDelete"
import SearchIcon from '@mui/icons-material/Search';
import CleaningServicesOutlinedIcon from '@mui/icons-material/CleaningServicesOutlined';
import IconButton from '@mui/material/IconButton';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';

import authService from '../api-authorization/AuthorizeService'
import { Breadcrumbs } from '../General/Breadcrumbs';

export class BLs_Index extends Component {
    static displayName = BLs_Index.name;
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            loading: true,
            modalState: false,
            modalHeader: "Cargando",
            modalBody: () => { return (<div>Cargando</div>); },
            modalOperation: 'add',
            modalIsValid: false,
            searchModel: { nombre: "", carga: "" },
            vaporSemanal: {},
            calibres: [],
            cajasPorPaleta: [],
            paises: [],
        };
        this.load_vaporSemanal = this.load_vaporSemanal.bind(this);
        this.populateData = this.populateData.bind(this);
        this.modalBodyState = {};
        this.modalToggle = this.modalToggle.bind(this);
        this.add_onclick = this.add_onclick.bind(this);
        this.add_modal_guardar_onclick = this.add_modal_guardar_onclick.bind(this);
        this.edit_onclick = this.edit_onclick.bind(this);
        this.edit_modal_guardar_onclick = this.edit_modal_guardar_onclick.bind(this);
        this.delete_onclick = this.delete_onclick.bind(this);
        this.delete_modal_guardar_onclick = this.delete_modal_guardar_onclick.bind(this);
        this.setModalBodyState = this.setModalBodyState.bind(this);
        this.modalSubmit = this.modalSubmit.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.clean_onclick = this.clean_onclick.bind(this);
    }

    componentDidMount() {
        this.populateData();
    }

    modalToggle() {
        this.setState({
            modalState: !this.state.modalState
        });
    }

    renderTable() {
        return (
            <div  >
                <Row>
                    <Form >
                        <Row>
                            <Col md="4">
                                <FormGroup>
                                    <Label for="nombre">
                                        <FormattedMessage id='Nombre' />
                                    </Label>
                                    <Input
                                        id="nombre"
                                        name="nombre"
                                        type="text"
                                        onChange={this.handleSearchChange}
                                        value={this.state.searchModel.nombre}
                                    />

                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label for="carga">
                                        <FormattedMessage id='Carga' />
                                    </Label>
                                    <Input
                                        id="carga"
                                        name="carga"
                                        type="select"
                                        onChange={this.handleSearchChange}
                                        value={this.state.searchModel.carga}
                                    >
                                        <option value=""></option>
                                        <option value="Bodega">Bodega</option>
                                        <option value="Cubierta">Cubierta</option>

                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col className="col-auto">
                                <FormGroup>
                                    <IconButton size='small' className='SearchButton IndexButton' onClick={this.populateData}>
                                        <SearchIcon />
                                    </IconButton>
                                </FormGroup>
                            </Col>
                            <Col className="col-auto">
                                <FormGroup>
                                    <Button className="CleanButton IndexButton" onClick={this.clean_onclick}>
                                        <CachedOutlinedIcon fontSize='large' /> <FormattedMessage id='Limpiar' />
                                    </Button>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </Row>
                <Row>
                    <BLsTable data={this.state.data} add_onclick={this.add_onclick} edit_onclick={this.edit_onclick} delete_onclick={this.delete_onclick} />
                </Row>
                <Modal isOpen={this.state.modalState} toggle={this.modalToggle}>
                    <ModalHeader toggle={this.modalToggle}>
                        {this.state.modalHeader}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.modalBody}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.modalSubmit} disabled={!this.state.modalIsValid}>
                            {this.state.modalOperation == 'delete' ? <FormattedMessage id='Eliminar' /> : <FormattedMessage id='Guardar' />}
                        </Button>{' '}
                        <Button color="secondary" onClick={this.modalToggle}>
                            Cancelar
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

    render() {
        let breadcrumbsData = this.state.loading
            ? <p></p>
            : <Breadcrumbs data={[
                { link: "/Semanas", message: "Semanas", active: true },
                { link: "/Semanas/" + this.state.vaporSemanal.semana_Id + "/VaporesSemanalesProveedor", message: "Vapores", active: true },
                { link: "/VaporesSemanales/" + this.state.vaporSemanal.vaporSemanalProveedor_Id + "/BLs", message: "BLs", active: false },
            ]} />;
        let contents = this.state.loading
            ? <p><em>Cargando...</em></p>
            : this.renderTable();


        return (
            <div style={{ width: '800px' }}>
                <h2><FormattedMessage id='BLs' /></h2>
                {breadcrumbsData}

                <div className="viewContainerHeader ">
                    <div className="d-flex justify-content-start">
                        <div className="px-4 py-2"><FormattedMessage id='Semana' />: {this.state.vaporSemanal.semana}</div>
                    </div>
                    <div className="d-flex justify-content-start">
                        <div className="px-4 py-2"><FormattedMessage id='Naviera' />: {this.state.vaporSemanal.naviera}</div>
                        <div className="px-4 py-2"><FormattedMessage id='Barco' />: {this.state.vaporSemanal.barco}</div>
                        <div className="px-4 py-2"><FormattedMessage id='Viaje' />: {this.state.vaporSemanal.viaje}</div>
                    </div>
                </div>
                <div className="viewContainer-lg">
                    {contents}
                </div>

            </div>
        );
    }

    async populateData() {
        this.setState({
            loading: true,
            vaporSemanal: await this.load_vaporSemanal(),
        }, async () => {
            this.setState({
            }, async () => {
                const token = await authService.getAccessToken();
                var queryString = '?vaporSemanalProveedor_Id=' + this.state.vaporSemanal.vaporSemanalProveedor_Id + '&';
                Object.keys(this.state.searchModel).forEach(key => {
                    queryString += key + "=" + this.state.searchModel[key] + "&";
                });
                queryString = queryString.slice(0, -1);
                const response = await fetch('api/bls' + queryString, {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
                });
                const responceData = await response.json();
                this.setState({ data: responceData, loading: false });

            });
        });
        
    }

    handleSearchChange(event) {
        event.preventDefault();
        var searchModel = this.state.searchModel;
        searchModel[event.target.name] = event.target.value;
        this.setState({ searchModel: searchModel }, () => {

        });

    }
    async modalSubmit(id) {
        if (this.state.modalOperation == 'add') {
            this.add_modal_guardar_onclick();
        }
        else if (this.state.modalOperation == 'edit') {
            this.edit_modal_guardar_onclick(id);
        }
        else if (this.state.modalOperation == 'delete') {
            this.delete_modal_guardar_onclick(id);
        }
    }
    async add_onclick() {
        this.setState({
            modalHeader: this.add_modal_header(),
            modalBody: this.add_modal_body(),
            modalState: true,
            modalOperation: 'add',
        });
    }
    add_modal_header() {
        return (<div><FormattedMessage id='Nuevo' /></div>);
    }
    add_modal_body() {
        return (<div><BLsView operation={this.state.modalOperation} setModalBodyState={this.setModalBodyState}></BLsView></div>);
        //return (<div><BLsView ref={this.modalBodyState}></BLsView></div>);
    }
    async add_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.modalBodyState);
        const response = await fetch('api/bls', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
        //const responceData = await response.json();
    }
    async edit_onclick(id) {
        const modalBody = await this.edit_modal_body(id);
        this.setState({
            modalHeader: this.edit_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'edit',
        });
    }
    edit_modal_header(id) {
        return (<div><FormattedMessage id='Editar' /></div>);
    }
    async edit_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/bls/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        return (<div><BLsView operation={this.state.modalOperation} setModalBodyState={this.setModalBodyState} data={responceData}></BLsView></div>);
        //return (<div><BLsView ref={this.modalBodyState}></BLsView></div>);
    }
    async edit_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.modalBodyState);
        const response = await fetch('api/bls/' + this.modalBodyState.bL_Id, {
            method: 'PUT',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async delete_onclick(id) {
        const modalBody = await this.delete_modal_body(id);
        this.setState({
            modalHeader: this.delete_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'delete',
            modalIsValid: true
        });
    }
    delete_modal_header(id) {
        return (<div><FormattedMessage id='Eliminar' /></div>);
    }
    async delete_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/bls/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        await this.setModalBodyState({ model: responceData });
        return (<div><BLsDelete setModalBodyState={this.setModalBodyState} data={responceData}></BLsDelete></div>);
    }
    async delete_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/bls/' + this.modalBodyState.bL_Id, {
            method: 'DELETE',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async clean_onclick() {
        this.setState({
            searchModel: { nombre: "", carga: "" }
        });
        await this.populateData()
    }

    async setModalBodyState(state) {
        this.modalBodyState = state.model;
        if (state.modelValidation) {
            var modalIsValid = !Object.keys(state.modelValidation).some(function (val) {
                return state.modelValidation[val] == false;
            });
            this.setState({
                modalIsValid: modalIsValid
            });
        }

    }
    async load_vaporSemanal() {
        var rawUrl = window.location.toString();
        var vaporSemanalProveedor_Id = rawUrl.split("VaporesSemanales/")[1].split("/")[0];
        const token = await authService.getAccessToken();
        const response = await fetch('api/vaporesSemanalesProveedor/' + vaporSemanalProveedor_Id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    
}